export default __webpack_public_path__ + "static/media/misc-makeupA-1920w.77b9f6fb.png";